import { AlmeAppUtilsBase } from './../components/AlmeApp/AlmeAppState';
import MessageType from './MessageType';
import SwitchAccountHandler from './MessageHandlers/SwitchAccountHandler';
import LaunchIvaHandler from './MessageHandlers/LaunchIvaHandler';
import ContinueSessionHandler from './MessageHandlers/ContinueSessionHandler';
import ManageAccountsHandler from './MessageHandlers/ManageAccountsHandler';
import DeepLinkRespHandler from './MessageHandlers/DeepLinkRespHandler';
import PlatformDataRefreshHandler from './MessageHandlers/PlatformDataRefreshHandler';
export class AlmeMessageHandlerUtils extends AlmeAppUtilsBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils, setDelayPostMessageHandle, ivaSetChatStatus, setAlmeAppConfig) {
        super(almeState, setAlmeState, appConfig);
        this.apiUtils = apiUtils;
        this.setDelayPostMessageHandle = setDelayPostMessageHandle;
        this.ivaSetChatStatus = ivaSetChatStatus;
        this.setAlmeAppConfig = setAlmeAppConfig;
    }
    Handle(eventData) {
        const message = eventData.message;
        this.HandleMessage(message);
    }
    HandleMessage(message) {
        let messageHandler;
        switch (message.type) {
            case MessageType.SwitchAcctIva:
                messageHandler = new SwitchAccountHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils);
                break;
            case MessageType.LaunchIva:
                messageHandler = new LaunchIvaHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils, this.ivaSetChatStatus);
                break;
            case MessageType.ActiveCCSessonIVA:
                messageHandler = new ContinueSessionHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils);
                break;
            case MessageType.ManageAcctIva:
                if (this.almeState.historyLoaded) {
                    messageHandler = new ManageAccountsHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils);
                }
                else {
                    this.setDelayPostMessageHandle(message);
                    return;
                }
                break;
            case MessageType.DeepLinkRespIva:
                messageHandler = new DeepLinkRespHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils);
                break;
            case MessageType.PlatformAccountDataRefresh:
                messageHandler = new PlatformDataRefreshHandler(this.almeState, this.setAlmeState, this.appConfig, this.apiUtils, this.setAlmeAppConfig);
                break;
        }
        if (messageHandler) {
            messageHandler.handle(message);
        }
    }
}
